import React from 'react'
import styled from 'styled-components'
import Iframe from 'react-iframe'
import { useMoonPayUrl } from 'hooks/api'

const StyledIframe = styled(Iframe)`
  width: 100%; 
  max-width: 398px;
  height: calc(100vh - 130px);
  max-height: 738px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 16px;
  border-radius: 1rem;
  min-width: 330px;

  & > div {
    grid-column: span 12;
    width: 100%;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    & > div {
      height: 1200px;
    }
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    & > div {
      height: 860px;

    }
  }
  ${({ theme }) => theme.mediaQueries.md} {
    & > div {
      height: 860px;
    }
  }
`

const MoonPayIframe: React.FC = () => {

  return (
    <StyledIframe
      title="Moonpay topup"
      url="https://buy.onramper.com/?themeName=dark&onlyCryptos=BNB_BSC,BUSD_BSC&amp;containerColor=080f0f&amp;primaryColor=53b28c&amp;secondaryColor=122f36&amp;cardColor=122f36&amp;primaryTextColor=ffffff&amp;secondaryTextColor=62d5a3&amp;borderRadius=1&amp;wgBorderRadius=1&amp;defaultAmount=50&amp;defaultCrypto=BNB_BSC&amp;supportSell=false&amp;supportSwap=false&amp;defaultAddrs=%5Bobject+Object%5D"
      scrolling="no"
      allow="accelerometer; autoplay; camera; gyroscope; payment"
    />
  )
}

export default MoonPayIframe
